import {Button, Center, Loader, Text, TextInput} from "@mantine/core";
import { Contact } from "../types/Contact";
import { closeAllModals, openModal } from "@mantine/modals";
import React, { FC, useState } from "react";
import { useForm } from "@mantine/form";
import { isDefined } from "../Utils/utils";
import { ContactS } from "../Service/restapi/contactService";

interface Props {
  contact: Contact;
  profileId: number;
  documentType: 'CONTRACT' | 'OFFER' | 'QUESTIONNAIRE';
  onFinish: (contact: Contact) => unknown;
}

const getDocumentLabel = (documentType: Props["documentType"]) => {
  if (documentType === "CONTRACT") {
    return { subject: "Vertrag", object: "den Vertrag" };
  }
  if (documentType === "QUESTIONNAIRE") {
    return { subject: "Fragebogen", object: "den Fragebogen" };
  }
  return { subject: "Angebot", object: "das Angebot" };
};

export const openCustomerAddressModal = (props: Props) =>
  openModal({
    title: (
      <Text weight="bolder" size="xl">
          {getDocumentLabel(props.documentType).subject} bestätigen
      </Text>
    ),
    children: <CustomerAddressModal {...props} />,
  });

const CustomerAddressModal: FC<Props> = ({ contact, onFinish, profileId, documentType }) => {
  const { id, addressStreetAndNo, zipCode, city, phoneNumber, partner } = contact;
  const [loading, setLoading] = useState(false);
  const documentLabel = getDocumentLabel(documentType);

  const form = useForm({
    initialValues: { addressStreetAndNo, zipCode, city, phoneNumber, partnerFirstName : partner?.firstName, partnerLastName : partner?.lastName },
    validate: {
      addressStreetAndNo: (val: string) =>
        isDefined(val) ? null : "Bitte Wert eingeben",
      zipCode: (val: string) => (isDefined(val) ? null : "Bitte Wert eingeben"),
      city: (val: string) => (isDefined(val) ? null : "Bitte Wert eingeben"),
    },
  });

  const onSubmit = async () => {
    setLoading(true);
    const { values } = form;
    if (partner && (partner.firstName == null || partner.lastName == null)) {
        await ContactS.edit(partner.id, {firstName: values.partnerFirstName, lastName: values.partnerLastName}, profileId);
    }
    const resJSON = await ContactS.edit(id, {addressStreetAndNo : values.addressStreetAndNo, zipCode : values.zipCode, city : values.city, phoneNumber: values.phoneNumber}, profileId);
    setLoading(false);
    if (resJSON) {
      closeAllModals();
      onFinish(resJSON);
    }
  };

  const askPartnerName = partner && (!partner.firstName || !partner.lastName);

  return (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Text mb="md">
        Bitte vervollständige die folgenden Angaben, um {documentLabel.object} zu bestätigen:
      </Text>
      {askPartnerName && <TextInput required mt="sm" label="Partner Vorname" {...form.getInputProps("partnerFirstName")} />}
      {askPartnerName && <TextInput required mt="sm" label="Partner Nachname" {...form.getInputProps("partnerLastName")} />}
      <TextInput
        required
        mt="sm"
        label="Straße und Hausnummer"
        {...form.getInputProps("addressStreetAndNo")}
      />
      <TextInput required mt="sm" label="PLZ" {...form.getInputProps("zipCode")} />
      <TextInput required mt="sm" label="Stadt" {...form.getInputProps("city")} />
      <TextInput required mt="sm" label="Telefonnummer" {...form.getInputProps("phoneNumber")} />

        <Center mt={40}>
        <Button
          disabled={loading || !form.isDirty()}
          type="submit"
          rightIcon={loading && <Loader size="xs" />}
        >
          Speichern und {documentLabel.subject} bestätigen
        </Button>
      </Center>
    </form>
  );
};
